const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

/** ₹1,249 — whole rupees, Indian digit grouping. */
export function formatINR(amount: number): string {
  return inrFormatter.format(Math.round(amount));
}

const numberFormatter = new Intl.NumberFormat("en-IN");

export function formatNumber(value: number): string {
  return numberFormatter.format(value);
}

const TIME_ZONE = "Asia/Kolkata";

/** "Sat, 15 Nov" */
export function formatDate(
  value: string | Date,
  options: Intl.DateTimeFormatOptions = { weekday: "short", day: "numeric", month: "short" },
): string {
  return new Intl.DateTimeFormat("en-IN", { timeZone: TIME_ZONE, ...options }).format(
    new Date(value),
  );
}

/** "15 Nov 2026" */
export function formatLongDate(value: string | Date): string {
  return formatDate(value, { day: "numeric", month: "short", year: "numeric" });
}

/** "6:38 AM" */
export function formatTime(value: string | Date): string {
  return new Intl.DateTimeFormat("en-IN", {
    timeZone: TIME_ZONE,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })
    .format(new Date(value))
    .toUpperCase();
}

/** "15 Nov, 6:38 AM" */
export function formatDateTime(value: string | Date): string {
  return `${formatDate(value, { day: "numeric", month: "short" })}, ${formatTime(value)}`;
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${formatNumber(count)} ${count === 1 ? singular : plural}`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

/** Masks a 10-digit mobile number: "+91 88065 •••55" */
export function maskPhone(phone: string): string {
  const digits = phone.replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) return phone;
  return `+91 ${digits.slice(0, 5)} •••${digits.slice(8)}`;
}

/** "+91 98220 41163" */
export function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) return phone;
  return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
}

export function discountPercent(price: number, mrp: number | null | undefined): number | null {
  if (!mrp || mrp <= price) return null;
  return Math.round(((mrp - price) / mrp) * 100);
}
